import { FooterActionBar } from 'common/components/FooterActionBar';
// import { isPOCreated } from 'purchaseOrder/view';
import React, { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { CorporateWorkgroupValues } from '../../types';
import { isPOCreated } from 'purchaseOrder/view';

interface FooterProps {
  isNew: boolean;
  isLoading: boolean;
  children?: ReactNode;
  onSave: (saveAnother: boolean) => void;
}

export const Footer: React.FC<FooterProps> = ({
  isNew,
  onSave,
  isLoading,
  children,
}) => {
  const {
    formState: { isDirty, isSubmitting, isValid },
  } = useFormContext<CorporateWorkgroupValues>();

  const history = useHistory();

  return (
    <>
      <FooterActionBar
        createNewText="New Workgroup"
        addNewForm={() => {
          history.replace('/account-management/work-groups/work-group');
        }}
        disabled={{
          save: !isDirty || !isValid,
          cancel: !isDirty,
        }}
        isSubmitting={isSubmitting}
        isCreate={isNew}
        onCancel={() => history.replace('/account-management/work-groups')}
        onSave={() => {
          onSave(false);
        }}
        onSaveAnother={async () => {
          onSave(true);
          isPOCreated(false);
        }}
        isLoading={isLoading}
        children={children}
      />
    </>
  );
};
